import { configureStore } from "@reduxjs/toolkit";
import { apiSlice } from "./shared/slices/apiSlice";
import jobReducer from './modules/createJob/slice/jobSlice'
import companyReducer from './modules/createJob/slice/companySlice'
import candidatesReducer from './modules/createJob/slice/candidateSlice'
import authReducer from './modules/authentication/slice/authSlice'
import jobsListReducers from './modules/viewJobs/slice/jobListSlice'
import settingsReducer from './modules/settings/slice/settingsSlice'
import tabsReducer from './shared/components/Tabs/slice/tabsSlice';
import tabsMenuReducer from './shared/components/Menu/slice/tabsMenuSlice';
import reportsReducer from './modules/reports/slice/reportsSlice';
import pipelinesReducer from './modules/settings/slice/pipelinesSlice';
import templatesReducer from './modules/settings/slice/templatesSlice';
import automatedActionsReducer from './modules/settings/slice/automatedActionsSlice';
import departmentsReducer from './modules/settings/slice/departmentsSlice';
import interviewReducer from './modules/interview/slice/interviewSlice';
import contactUsReducer from './modules/ContactUsForm/slice/contactusSlice';
import calendarReducer from './shared/components/Calendar/slice/calendarSlice';
import aiInterviewReducer from './modules/aiInterviewer/slice/aiInterviewSlice';
const store = configureStore({
    reducer: {
        [apiSlice.reducerPath]: apiSlice.reducer,
        job: jobReducer,
        auth: authReducer,
        jobsList: jobsListReducers,
        company: companyReducer,
        candidates: candidatesReducer,
        settings: settingsReducer,
        tabs: tabsReducer,
        tabsMenu: tabsMenuReducer,
        reports: reportsReducer,
        pipelines: pipelinesReducer,
        templates: templatesReducer,
        automatedActions: automatedActionsReducer,
        departments: departmentsReducer,
        interview: interviewReducer,
        contactUs: contactUsReducer,
        calendar: calendarReducer,
        aiInterview: aiInterviewReducer
    },

    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: false,
        }).concat(apiSlice.middleware),
    
})
export default store;